import { UtilitariosFlowModule } from './utilitarios-flow/utilitarios-flow.module';
import { NgModule } from '@angular/core';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { SharedAdministrationModule } from '../shared-administration/shared-administration.module';
import { Ng2SmartTableModule } from 'ng2-smart-table';

// Local components
import { UtilitariosManagementComponent } from './utilitarios-management.component';
import { CalendarComponent } from './calendar/calendar.component';
import { CommonModule } from '@angular/common';
import { UserPersistentComponent } from './user-persistent/user-persistent.component';
import { UserInstanceProcedureComponent } from './users-instance-procedure/users-instance-procedure.component';




@NgModule({
  imports: [
    CommonModule,
    SharedAdministrationModule,
    UtilitariosFlowModule,
    Ng2SmartTableModule,
    ButtonsModule.forRoot()
  ],
  declarations: [
    UtilitariosManagementComponent,
    CalendarComponent,
    UserPersistentComponent,
    UserInstanceProcedureComponent

  ],
  exports: [
    UtilitariosManagementComponent
  ],
  entryComponents: [


  ],
  providers: []
})
export class UtilitariosManagementModule {}



// WEBPACK FOOTER //
// ./src/app/administration/utilitarios-management/utilitarios-management.module.ts